import React from "react";
import { CurrentOrNextEventProvider } from "../../../../hooks/useCurrentOrNextEvent/useCurrentOrNextEvent";
import { useAIMessageContext } from "../hooks/AIMessageContext";
import { useCollaborators } from "../hooks/useCollaborators";
import { AINextMeetingLink } from "./AINextMeetingLink";
import { CustomCollaborators } from "./CustomCollaborators";
import { TryClockwiseChecklist } from "./TryClockwiseChecklist";

export const SidebarQuickFeed = () => {
  const { loadingHistory } = useAIMessageContext();
  const {
    topCollaborators,
    customCollaborators,
    loading: collaboratorsLoading,
  } = useCollaborators();

  if (loadingHistory) return null;

  return (
    <CurrentOrNextEventProvider>
      <div className="cw-flex cw-flex-col cw-gap-5 cw-w-full cw-h-full">
        <AINextMeetingLink />
        <CustomCollaborators
          loading={collaboratorsLoading}
          topCollaborators={topCollaborators}
          customCollaborators={customCollaborators}
        />
        <TryClockwiseChecklist />
      </div>
    </CurrentOrNextEventProvider>
  );
};
